import $ from "jquery";

export const startResendTimer = (btnSelector, timerSelector, seconds) => {
    const formatTime = (s) => {
        const m = String(Math.floor(s / 60)).padStart(2, '0');
        const sec = String(s % 60).padStart(2, '0');
        return m + ':' + sec;
    };

    $(btnSelector).prop('disabled', true);
    let remaining = seconds;
    $(timerSelector).text(formatTime(remaining));

    const interval = setInterval(() => {
        remaining--;
        $(timerSelector).text(formatTime(remaining));
        if (remaining <= 0) {
            clearInterval(interval);
            $(btnSelector).prop('disabled', false);
            $(timerSelector).text('00:00');
        }
    }, 1000);
};